import React from "react";
import * as Mui from "@mui/material";
import { withStyles } from "tss-react/mui";
import type { WithStyles } from "type/tss";
import { CriterionResource } from "api/resource/criterion";
import { styles } from "./style";

interface CriterionCardProps extends WithStyles<typeof styles> {
	criterion: CriterionResource;
}

const Component: React.FC<CriterionCardProps> = ({ classes = {}, criterion }) => {
	const theme = Mui.useTheme();
	
	const getValueDisplay = (value: any): string => {
		if (Array.isArray(value)) {
			return value.join(', ');
		}
		if (typeof value === 'boolean') {
			return value ? 'Yes' : 'No';
		}
		return String(value);
	};

	const getValueChipColor = (): 'default' => {
		return 'default';
	};

	return (
		<Mui.Box 
			border={1} 
			borderColor="grey.300" 
			borderRadius={1} 
			p={1} 
			mb={1}
			className={classes.container}
		>
			<Mui.Box display="flex" justifyContent="space-between" alignItems="center">
				<Mui.Typography variant="caption" className={classes.label}>
					{criterion.label}
				</Mui.Typography>
				{criterion.area && (
					<Mui.Chip 
						label="Area" 
						size="small" 
						variant="outlined" 
						className={classes.areaChip}
					/>
				)}
			</Mui.Box>
			<Mui.Typography variant="caption" color="textSecondary" className={classes.fieldName}>
				{criterion.name}
			</Mui.Typography>
			<Mui.Box mt={0.5}>
				<Mui.Chip
					label={getValueDisplay(criterion.value)}
					size="small"
					color={getValueChipColor()}
					className={classes.valueChip}
				/>
			</Mui.Box>
		</Mui.Box>
	);
};

export const CriterionCard = withStyles(Component, styles);